import { useCallback } from 'react';

import { usePetitionEditBannerState } from 'src/app/pages/petitionEditV2/pageContext';

export function usePageBanner() {
	const { data, actions } = usePetitionEditBannerState();

	const handleDismiss = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>) => {
			if (!data.currentBanner) return;
			data.currentBanner.onClose?.(e);
			actions.dismissBanner();
		},
		[actions, data.currentBanner],
	);

	return { data: { banner: data.currentBanner }, actions: { onDismiss: handleDismiss } };
}
